const e = (r) => {
  if (typeof r == "string") return r;
  if (Array.isArray(r)) return "";
  if (typeof r == "object") {
    const t = r?.props?.children;
    if (t) return e(t);
  }
  return "";
};
export {
  e as recursivelyGetChildrenString
};
